import { Injectable, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable, of, skipWhile, switchMap } from 'rxjs';

import { CircleService } from '../services/circle.service';

@Injectable({
  providedIn: 'root',
})
export class SbRoleGuard implements CanActivate {
  private circleService = inject(CircleService);
  private router = inject(Router);
  private userInfo$ = toObservable<any>(this.circleService.userInfo);

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean> {
    const expectedRoles: string[] = next.data['roles'];
    return this.userInfo$.pipe(
      skipWhile(value => value === undefined),
      switchMap(user => {
        if (user) {
          const userRoles = (user as any)?.sb_roles || [];
          const hasRoles = expectedRoles.some(role => userRoles.includes(role));

          if (!hasRoles) {
            this.router.navigate(['unauthorized']);
          }
          return of(hasRoles);
        } else {
          this.router.navigate(['unauthorized']);
          return of(false);
        }
      }),
    );
  }
}
